import { useEffect, useRef, useState } from "react";

/**
 * Fires `visible=true` the first time the element enters the viewport.
 * Small, dependency-free replacement for animation libraries.
 */
export const useInView = (options = { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!ref.current || visible) return;
    const el = ref.current;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisible(true);
            io.unobserve(entry.target);
          }
        });
      },
      options,
    );
    io.observe(el);
    return () => io.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [ref, visible];
};

export default useInView;
